import {enrollFactor, activateWebAuthn} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useState} from "react";
import {toast} from "react-toastify";
import crypto from '../../../utils/crypto';
import {AuthBack, AuthBox, AuthButton, AuthContent, AuthIcon} from "../../common/AuthBox";
import IconUser from "../../../../images/icon_user.png";
import IconWebAuthn from "../../../../images/icon_webAuthn.png"
import {useHistory} from "react-router-dom";
import {useFactors} from "../../../contexts/FactorsContext";
import IconError from "../../../../images/error.png";

const fidoRpId =  process.env.REACT_APP_FIDO_RP_ID;
const OktaEnrollWebAuth = () => {
    const [enrollStep, setEnrollStep] = useState(1);
    const history = useHistory();
    const {refresh} = useFactors();
    const [error, setError] = useState(null);

    const toStep2 = () => {
        setEnrollStep(2);
    }

    const enroll = async () => {

        setError(false);
        const enrollWebAuthnResponse = await runApi(
            'enrollWebAuthn',
            () => enrollFactor("webauthn", "FIDO")
        );

        if (!enrollWebAuthnResponse?.data?.status) {
            setError(true);
            return;
        }

        let keyInfo = enrollWebAuthnResponse?.data?.data;

        if (!keyInfo) {
            setError(true);
            return;
        }

        let factorId = keyInfo.id;

        keyInfo._embedded.activation.challenge = crypto.strToBin(keyInfo._embedded.activation.challenge);
        keyInfo._embedded.activation.user.id = crypto.strToBin(keyInfo._embedded.activation.user.id);
        keyInfo._embedded.activation.excludeCredentials.forEach(function (item, index, arr) {
                arr[index].id = crypto.strToBin(arr[index].id);
            }
        )

        keyInfo._embedded.activation.rp.id = fidoRpId;

        navigator.credentials.create({
            publicKey: keyInfo._embedded.activation
        })
            .then(function (newCredential) {
                let attestation = crypto.binToStr(newCredential.response.attestationObject);
                let clientData = crypto.binToStr(newCredential.response.clientDataJSON);
                activate(factorId, attestation, clientData);
            }).catch(function (err) {
            setError(true);

        });
    }


    const activate = async (factorId, attestation, clientData) => {
        const activateWebAuthnApi = await runApi(
            'activateWebAuthn',
            () => activateWebAuthn(factorId, attestation, clientData)
        );


        if (!activateWebAuthnApi?.data?.status) {
            return;
        }

        toast.success("Activate webAuthn successfully.")
        finishActivate();
    }

    const finishActivate = () => {
        refresh();
        history.push('/profile/mfa');
    }

    return (
        <AuthBox>
            <AuthIcon src={enrollStep === 1 ? IconUser : IconWebAuthn}/>
            {enrollStep === 1 && <AuthContent><p><strong>Set up multifactor authentication</strong></p>
                <p>Your company requires multifactor authentication to add an additional layer of security when
                    signing in to your Okta account.</p>
                <div className="google-authenticator clearfix">
                    <img src={IconWebAuthn} className="icon_GA" alt={'webAuthn'}/>
                    <div className="right">
                        <p><strong>Security Key or Biometric Authenticator</strong></p>
                        <p>Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID,
                            etc.)</p>
                        <button className="btn_setup" onClick={() => toStep2()}>Setup</button>
                    </div>
                </div>
            </AuthContent>}
            {enrollStep === 2 && <AuthContent>
                {error &&
                <div className="infobox-error clearfix">
                    <span className="error-icon"><img src={IconError} alt="error" width="16"/></span>
                    <p>The operation either timed out or was not allowed. See:
                        https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client.</p>
                </div>
                }
                <div className="right"><p><strong>Set up security key or biometric authenticator</strong></p>
                    <p>Your browser will prompt to register a security key or biometric authenticator (Windows Hello,
                        Touch ID, etc.). Follow the instructions to complete enrollment.</p>
                    <div className="google-authenticator clearfix">

                        <AuthButton buttonEvent={() => enroll()} buttonText={"Enroll"}/></div>
                </div>
                <AuthBack src="/profile/mfa/enroll/FIDO/webauthn"/></AuthContent>}</AuthBox>
    );
};

export default OktaEnrollWebAuth;
